var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCartBagOutlinedDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none",
    viewBox: "0 0 20 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#bab4c3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M13.376 9V4.5a3.75 3.75 0 0 0-7.5 0V9m11.356-1.993 1.263 12c.07.665-.45 1.243-1.119 1.243h-15.5a1.126 1.126 0 0 1-1.12-1.243l1.264-12A1.125 1.125 0 0 1 3.14 6h12.973c.576 0 1.06.435 1.12 1.007M6.252 9a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0m7.5 0A.375.375 0 1 1 13 9a.375.375 0 0 1 .75 0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartBagOutlinedDark);
export default __webpack_public_path__ + "static/media/cart_bag_outlined_dark.12688e8e71586db190f9f82d1f12e7c3.svg";
export { ForwardRef as ReactComponent };